export class UserWaterViewModel {
    water_target?: number;
    min_water_target?: number;
    consumed?: number;
}
